
 const tab = {
  namespaced: true,
  state:{
    openTab:[],//所有打开的路由
    activeTab:'' //激活状态
  },
  mutations:{
    // 添加tabs
    add_tabs:function(state, data){
      this.state.tab.openTab.push(data);
    },
    // 删除tabs
    delete_tabs:function(state, route){
      let index = 0;
      for (var i=0;i<state.openTab.length;i++) {
        if (state.openTab[i].route === route) {
          break;
        }
        index++;
      }
      this.state.tab.openTab.splice(index, 1);
    },
    // 设置当前激活的tab
    set_active_index:function(state, index){
      this.state.tab.activeTab = index;
    },
  },
  actions:{

  }
}
export default tab;

